import {IFieldDescriptor} from '@/features/mixer'
import {InitViewAsk} from './views/ask'
import {InitViewSimilarity} from './views/similarity'
import {InitViewExpression} from './views/expression'

export interface IInitViewTemplateProps {
  descriptor: IFieldDescriptor
  finalize: (descriptor: IFieldDescriptor, initParams?: unknown) => void
  data?: any
}

export type InitViewTemplate = (props: IInitViewTemplateProps) => React.ReactElement

export const InitViewTemplates = {
  ask: InitViewAsk,
  similarity: InitViewSimilarity,
  expression: InitViewExpression,
}

export type InitViewTemplateIDs = keyof typeof InitViewTemplates
